import { LinkProp, MAIN_LINKS, SUPPORT_LINKS } from './types';
import {
  CLIENTS_PATH,
  DASHBOARD_PATH,
  DOCUMENTS_PATH,
  FREELANCERS_PATH, JOB_BOARD_PATH,
  PROJECT_OPPORTUNITIES_PATH,
  SETTINGS_PATH
} from '../../router/paths';

export const sidebarSetup = {
  [MAIN_LINKS.DASHBOARD]: {
    icon: 'dashboard',
    getPath: () => DASHBOARD_PATH,
    subTabs: []
  },
  [MAIN_LINKS.FREELANCERS]: {
    icon: 'person',
    getPath: () => FREELANCERS_PATH,
    subTabs: []
  },
  [MAIN_LINKS.DOCUMENTS]: {
    icon: 'file_copy',
    getPath: () => DOCUMENTS_PATH,
    subTabs: []
  },
  [MAIN_LINKS.CLIENTS]: {
    icon: 'business',
    getPath: () => CLIENTS_PATH,
    subTabs: []
  },
  [MAIN_LINKS.PROJECT_OPPORTUNITIES]: {
    icon: 'insights',
    getPath: () => PROJECT_OPPORTUNITIES_PATH,
    subTabs: []
  },
  [MAIN_LINKS.JOB_BOARD]: {
    icon: 'work_outline',
    getPath: () => JOB_BOARD_PATH,
    subTabs: []
  }
};

export const sidebarSupportSetup: { [key in SUPPORT_LINKS]: LinkProp } = {
  [SUPPORT_LINKS.SETTINGS]: {
    icon: 'settings',
    getPath: () => SETTINGS_PATH,
    subTabs: []
  },
};